import "core-js/modules/es.array.includes.js";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import CryptoJS from "crypto-js";
import { parseBigInt } from "jsencrypt/lib/lib/jsbn/jsbn";
import _ from "lodash";
// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgKd5XMG4BjBvL9wOG3OtwgYDrQmexZJs+ZEhWDuAsL2AXH59WbkPnGLLbaoLA0nKIr5ouNQiD8OKgIT0SY+xh8PKCASs43aKF6ka/tosRsLViN9YN8F3RMQIEergDmJ3+dB5zzQ1oaw3MHWRBO9zu3mHyulnUiS8gkU4dn1HPOctjXWP6FXNv7pYfz0uDS5zQTaSf3L8Qq9Zc1oadKiC8b45dUhAkvgXCvyuy2kGU8Iqgw/n9mgv6pJunty/EN6CSgPFqoH9SrNyw+uuFO/W+7AHaQRGPYBNw+lc3Ht5lOFeDKhthqb5ITfbKgk0zEuPhpDpPeuTzGGtGmx2mTertQIDAQAB";
const decodeKey = "iwk;POIU1234++==";
// 加密
const getRandom = () => {
  var arr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
    num = "";
  for (var i = 0; i < 16; i++) {
    num += arr[parseInt(Math.random() * 36)].charCodeAt().toString(16);
  }
  return num;
};
function pkcs1unpad2(d) {
  var b = d.toByteArray();
  var i = 0;
  while (i < b.length && b[i] === 0) {
    ++i;
  }
  // if (b.length - i !== n - 1 || b[i] !== 2) {
  //   return null
  // }
  ++i;
  while (b[i] !== 0) {
    if (++i >= b.length) {
      return null;
    }
  }
  var ret = "";
  while (++i < b.length) {
    var c = b[i] & 255;
    if (c < 128) {
      // utf-8 decode
      ret += String.fromCharCode(c);
    } else if (c > 191 && c < 224) {
      ret += String.fromCharCode((c & 31) << 6 | b[i + 1] & 63);
      ++i;
    } else {
      ret += String.fromCharCode((c & 15) << 12 | (b[i + 1] & 63) << 6 | b[i + 2] & 63);
      i += 2;
    }
  }
  return ret;
}
export const rsa = (body, keys) => {
  const key = getRandom();
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥
  let obj = {};
  _.mapKeys(body, (value, mykey) => {
    // if (_.includes(keys, mykey) &&) {

    if (_.includes(keys, mykey)) {
      console.log(mykey, value);
      if (!_.isEmpty(value)) {
        obj[mykey] = CryptoJS.AES.encrypt(value, CryptoJS.enc.Hex.parse(key), {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }).toString();
      } else {
        obj[mykey] = value;
      }
    }
  });
  console.log(obj);
  return {
    ...obj,
    key: encryptor.encrypt(key)
  };
};
// 密码加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥
  return encryptor.encrypt(txt); // 对需要加密的数据进行加密
}
// 密码解密
export function decode(txt) {
  return CryptoJS.AES.decrypt(txt, CryptoJS.enc.Utf8.parse(decodeKey), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString(CryptoJS.enc.Utf8);
}

// 公钥密码加密
export function decrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥rsaKey.decrypt = function(ctext) {
  const rsaKey = encryptor.getKey();
  rsaKey.decrypt = function (ctext) {
    var c = parseBigInt(ctext, 16);
    var m = this.doPublic(c);
    if (m == null) {
      return null;
    }
    return pkcs1unpad2(m);
  };
  return encryptor.decrypt(txt); // 对需要加密的数据进行加密
}